[
  {
    "id": 60,
    "question": "How do I change my password?",
    "answer": [
      "Add your username as normal and then click “Forgot your password” and follow the instructions."
    ]
  },
  {
    "id": 61,
    "question": "How can I upload driver cards to Vision?",
    "answer": [
      "Use the Vision uploader which you will need to install on your computer. You can get this by clicking your username and selecting the Vision uploader option.",
      "Driver cards can be imported from manual vehicle unit download devices through the import page.",
      "If you use telematics that have a feature to remote download the tachograph it is likely that we already have an integration set up to push the data directly into Vision. In the first instance check with your provider if they have this feature and if they integrate with Vision."
    ]
  },
  {
    "id": 62,
    "question": "How can I upload vehicle unit data to Vision?",
    "answer": [
      "Download the data manually to a download device and then use the Vision import page to upload the data to Vision.",
      "If you use telematics that have a feature to remote download the tachograph it is likely that we already have an integration set up to push the data directly into Vision. In the first instance check with your provider if they have this feature and if they integrate with Vision."
    ]
  },
  {
    "id": 63,
    "question": "How do I add a new driver to Vision",
    "answer": [
      "Upload the driver card in the usual way. The new drivers will go to the Holding area where you can add details to the driver profile before releasing their data for analysis.",
      "Add the drivers’ data manually through the “Add driver” button in Manage my drivers.",
      "Add multiple drivers by going to the import page and selecting “Drivers”. Download the form, complete the information and upload to Vision."
    ]
  },
  {
    "id": 64,
    "question": "How do I add a vehicle to Vision?",
    "answer": [
      "You can add a vehicle using the “Add vehicle” option on Manage my Fleet.",
      "Upload the vehicle unit data in the usual way. The new vehicles will go to the Holding area where you can add details to the vehicle profile before releasing data for analysis.",
      "Add multiple vehicles by going to the import page and selecting “Assets”. Download the form, complete the information and upload to Vision."
    ]
  },
  {
    "id": 65,
    "question": "How is training added to a drivers’ profile?",
    "answer": [
      "If you use Logistics UK to carry out training, and the drivers’ details are included on the Manage my drivers page, the training courses will upload automatically to Vision.",
      "You can add courses to drivers displayed in Vision within the driver profile training tab.",
      "You can upload training courses for multiple drivers by going to the import page and selecting DCPC training records. Download the form and complete then upload to Vision. No DCPC courses can also be added on this screen."
    ]
  },
  {
    "id": 66,
    "question": "Can I have any reports scheduled to be emailed to members of my team?",
    "answer": [
      "Yes. Logistics UK staff can set this up for you or you can do this yourself using the “Schedule report” option in Vision. For colleagues to be able to access their reports they must have a log in to Vision."
    ]
  },
  {
    "id": 67,
    "question": "Can I set up my own users to have a log in?",
    "answer": [
      "Yes. Users can be set up a role that suits the level of access you would like them to have. You can also restrict access to view only those locations you would like them to see."
    ]
  },
  {
    "id": 68,
    "question": "How do I set up a Vision account?",
    "answer": [
      "In the first instance contact our member services team on 03717 112222. Once you have a contract set up you will have access to Vision and be able to set up your own account preferences and users."
    ]
  },
  {
    "id": 69,
    "question": "How do I see my vehicle inspection reports on Vision?",
    "answer": [
      "Your Logistics UK Vehicle inspection reports are automatically uploaded to Vision on completion and will appear under the completed tab in the “Audits and inspections screen."
    ]
  }
]
